import { MEETING_STATUS_CANCELLED } from '../constants';

/**
 * Checks if a meeting is rejected.
 * Happens when at least one of the invitees cancelled/rejected the invite
 *
 * @param {Object} meeting - The meeting object to check.
 * @return {boolean} Returns true if the meeting is rejected, false otherwise.
 */
export function isMeetingRejected(meeting) {
    if (!meeting) return false;

    return meeting.invited?.length && meeting.invited?.some((m) => m.state == MEETING_STATUS_CANCELLED);
}
